import { connect } from 'react-redux'
import { sagaActions } from '../sagas'
import AddNewLayout from './AddNewLayout'

export default connect(
  null,
  {
    requestAddLayout: sagaActions.requestAddLayout
  }
)(AddNewLayout)
